<div class="row" *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<app-confirm-popup *ngIf="showModal" [title]="modalButton" [message]="modalMessage" [confirmText]="modalButton"
  [cancelText]="'Cancel'" [triggerModal]="showModal" (confirm)="onConfirm()" (cancel)="showModal = false">
</app-confirm-popup>

<div *ngIf="!isLoading" class="row">
  @if(categoryDataOriginal && categoryDataOriginal.length > 0){
  <div class="container col-md-5 d-flex flex-column">
    <div class="category-search-wrapper mt-2 mb-3">
      <div class="d-flex row justify-content-between align-items-baseline">
        <h6 class="mb-3 col-md-5">Select Categories</h6>
        @if(!reOrder){
        <div class="col-md-7 d-flex justify-content-end align-items-center">
          <button nz-button class="mr-10" nzType="primary" (click)="intiateNewCategory()">
            New Category / Product
          </button>
          <button nz-button class="d-flex justify-content-center align-items-center">
            <span style="width: 20px; height: 20px;" nz-dropdown nz-icon nzTrigger="click" [nzType]="'ellipsis'"
              [nzDropdownMenu]="menu"></span>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu class="category-options px-1 mt-1">
                <li nz-menu-item (click)="resetSelection(); reOrder=true">
                  <img class="expand-icon px-1" src="swap.png" />Reorder
                </li>
              </ul>
            </nz-dropdown-menu>
          </button>
        </div>
        }
        @if(reOrder){
        <div class="col-md-6 d-flex justify-content-end">
          <button (click)="saveReorder()" nz-button nzType="primary" class="d-flex align-items-center mr-10"
            [nzSize]="'default'">
            Save
          </button>
          <button nz-button nzType="default" class="d-flex align-items-center px-2"
            (click)="resetSelection(); reOrder=false" [nzSize]="'default'">
            Cancel
          </button>
        </div>
        }
      </div>
      <nz-input-group class="search-input-group" style="padding: 0 0 0 10px;" nzSize="default"
        [nzSuffix]="suffixIconSearch">
        <input type="text" class="py-1" nz-input placeholder="Search by Product Name, Lot or Style Id"
          (keydown.enter)="filterCategoryData(SearchText.value);" [(ngModel)]="searchText" nzAllowClear #SearchText />
        <span class="close-icon" (click)="SearchText.value = ''; filterCategoryData('')" class="px-1" nz-icon
          nzType="close-circle"></span>
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <button class="search-icon-btn" nz-button nzType="primary" nzSearch>
          <span (click)="filterCategoryData(SearchText.value);" nz-icon nzType="search"></span>
        </button>
      </ng-template>
    </div>

    <div class="tree-container px-2 pb-3" cdkScrollable>
      <div class="my-2" *ngIf="categoryData.length > 0">
        @if(reOrder){
        <div cdkDropList [cdkDropListData]="categoryData" cdkDropListOrientation="vertical"
          (cdkDropListDropped)="drop($event, categoryData)" class="row" [cdkDropListAutoScrollStep]="10">
          <nz-collapse nzGhost nzAccordion="true" class="no-rotate-accordion px-0 mb-2">
            <ng-container *ngFor="let category of categoryData; let i=index; trackBy: trackByCategoryId">

              <nz-collapse-panel cdkDrag [cdkDragDisabled]="category['isOpen']" [nzHeader]="customHeader"
                [nzExpandedIcon]="holderIcon" [nzActive]="category['isOpen']"
                (mouseenter)="handleHover(category, categoryData, true)" (cdkDragMoved)="onDragMove($event)"
                (mouseleave)="handleHover(category, categoryData, false)"
                (nzActiveChange)="onPanelClose($event, category, categoryData, i)" (click)="$event.stopPropagation()"
                [ngClass]="{ 'collapse-hover': category.hovered && !category['isOpen']}"
                [class.select-header]="category['seqno'] == apiService.activeSelection.selectedSeqId">

                <ng-template #customHeader>
                  <div class="d-flex justify-content-between px-2"
                    [ngClass]="{'highlight-header' : category['isOpen'] }">
                    <span class="w-50">{{ category['categoryname'] | decodeSpecialChar }}</span>
                    @if(category['hideonweb'] == 1){
                    <div class="d-flex justify-content-end w-50">
                      <img nz-tooltip="Product hidden on website" class="mr-10" [src]="'eye-invisible.svg'"  width="22px"
                            height="22px" />
                      <!-- <i class="fs-20 mr-10" nz-icon nzType='eye-invisible' nz-tooltip="Product hidden on website"></i> -->
                    </div>
                    }
                  </div>
                </ng-template>

                <ng-template #holderIcon>
                  <i class="holder-icon" cdkDragHandle nz-icon nzType='holder'
                    [ngClass]="{'highlight-header' : category['isOpen'] }"></i>
                </ng-template>
                @defer (when category['isOpen']) {
                <ng-container
                  *ngIf="category.categories?.length > 0 && category['lastcat'] === 0 && category['renderChild']">
                  <app-category-accordion-child [categories]="category" [catalogId]="catalogId"
                    [reOrder]="reOrder"></app-category-accordion-child>
                </ng-container>
                } @placeholder {
                <div *ngIf="category.categories?.length > 20 && category['lastcat'] === 0" class="p-3 text-center">
                  <!-- <i nz-icon nzType="loading" style="font-size: 20px;"></i> -->
                  <span class="fst-italic">Loading ...</span>
                </div>
                }
              </nz-collapse-panel>

            </ng-container>
          </nz-collapse>
        </div>
        }

        @if(!reOrder){
        <div class="row">
          <nz-collapse nzGhost nzAccordion="true" class="no-rotate-accordion px-0 mb-2">
            <ng-container *ngFor="let category of categoryData; let i=index; trackBy: trackByCategoryId">

              <nz-collapse-panel [nzHeader]="customHeader" [nzExpandedIcon]="skinIcon" [nzExtra]="customExpandIcon"
                [nzActive]="category['isOpen']" (mouseenter)="handleHover(category, categoryData, true)"
                (mouseleave)="handleHover(category, categoryData, false)" (click)="$event.stopPropagation();"
                (nzActiveChange)="onPanelClose($event, category, categoryData, i)"
                [ngClass]="{ 'collapse-hover': category.hovered && !category['isOpen']}"
                [class.select-header]="category['seqno'] == apiService.activeSelection.selectedSeqId">

                <ng-template #customHeader>
                  <div class="d-flex justify-content-between px-2" (click)="loadCategory(category)"
                    [ngClass]="{'highlight-header' : category['isOpen'] }">
                    <span class="w-50">{{ category['categoryname'] | decodeSpecialChar }}</span>
                    @if(category['hideonweb'] == 1){
                    <div class="d-flex justify-content-end w-50">
                      <!-- <i class="fs-20 mr-10" nz-icon nzType='eye-invisible' nz-tooltip="Product hidden on website"></i> -->
                       <img nz-tooltip="Product hidden on website" class="mr-10" [src]="'eye-invisible.svg'"  width="22px"
                            height="22px" />
                    </div>
                    }
                    <span class="dropdownIcon p-1" nz-dropdown [nzDropdownMenu]="menu"
                      (click)="$event.stopPropagation(); category['isMenuOpen']=true" nzTrigger="click"
                      [nzVisible]="category['isMenuOpen']" nz-icon nzType="ellipsis"></span>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu class="category-options px-1" (mouseleave)="onMenuLeave(category)">
                        <li (click)="duplicateCategory(category)" nz-menu-item>
                          <i class="expand-icon px-1" nz-icon [nzType]="'copy'"></i>Duplicate
                        </li>
                        <li (click)="deleteCategory(category)" nz-menu-item>
                          <i class="expand-icon px-1" nz-icon [nzType]="'delete'"></i>Delete
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                </ng-template>

                <ng-template #customExpandIcon>
                  <span class="p-2">
                    <i (click)="$event.stopPropagation(); onPanelClose(category['isOpen'] ? false : true, category, categoryData, i)"
                      class="expand-icon" nz-icon [nzType]="category['isOpen'] ? 'up' : 'down'"></i>
                  </span>
                </ng-template>

                <ng-template #skinIcon>
                  <i class="skin-icon" nz-icon nzType='skin' [ngClass]="{'highlight-header' : category['isOpen'] }"></i>
                </ng-template>
                <div
                  *ngIf="category['isOpen'] && !category['renderChild'] && category.categories?.length > 20 && category['lastcat'] === 0"
                  class="p-3 text-center">
                  <!-- <i nz-icon nzType="loading" class="text-primary" style="font-size: 20px;"></i> -->
                  <span class="fst-italic">Loading ...</span>
                </div>
                <ng-container
                  *ngIf="category.categories?.length > 0 && category['lastcat'] === 0 && category['renderChild']">
                  <app-category-accordion-child [categories]="category" [catalogId]="catalogId"
                    (emitSeqId)="loadChildCategory($event)"></app-category-accordion-child>
                </ng-container>
              </nz-collapse-panel>
              <nz-modal *ngIf="category.isPreviewOpen" (nzOnOk)="category.isPreviewOpen = false"
                [nzFooter]="modalFooter" (nzOnCancel)="category.isPreviewOpen = false" nzClosable nzCentered
                [nzWidth]="900" [(nzVisible)]="category.isPreviewOpen"
                [nzBodyStyle]="{ height: '550px', overflowY: 'auto' }" [nzTitle]="category['short-desc']">
                <ng-container *nzModalContent>
                  <app-catalog-preview></app-catalog-preview>
                </ng-container>
                <ng-template #modalFooter>
                  <button nz-button (click)="category.isPreviewOpen = false" nzType="primary">OK</button>
                </ng-template>
              </nz-modal>
            </ng-container>
          </nz-collapse>
        </div>
        }
      </div>
      <div class="text-center p-4 no-records ng-star-inserted" *ngIf="categoryData.length == 0">
        <span class="mb-3 fs-12">No categories found!</span>
      </div>
    </div>
  </div>
  }

  <app-add-edit-category (emitUpdateLots)="updateLots($event)" [ngClass]="getMDClass()"
    (emitCategoryTreeRefresh)="refreshCategoryTree($event)" [seqNumber]="selectedSeqId" [catalogId]="catalogId"
    [lots]="categoryLots" [categoryList]="categoryDataOriginal" (resetSelectedCategory)="resetSelection()"
    [intiateNewCategory]="newCategory">
  </app-add-edit-category>
</div>